<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <pow-customer-search-table
      class="mt-n10"
    ></pow-customer-search-table>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'Dashboard',
    components: {
      PowCustomerSearchTable: () => import('@/components/pow/PowCustomerSearchTable'),
    },

    data () {
      return {
      }
    },
    computed: {
      ...mapGetters(['accounts', 'customerMemberships', 'towerHeights', 'smHeights']),

    },
    async created () {
    },
    methods: {
      ...mapActions(['getAccounts']),
    },
  }
</script>
